function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
export var MINIMUM_VERSION_FOR_CODEC_SWITCHING = 'v3.3.10-v6';
export var MINIMUM_VERSION_FOR_FULL_EVENT = 'v3.3.10-v10';
export var MINIMUM_VERSION_FOR_NEW_CEA_PARSER = 'v3.3.10-v23';
export var MINIMUM_VERSION_FOR_MEDIA_QUALITY_CHANGED_EVENT = 'v3.3.10';
export var MINIMUM_VERSION_FOR_UPDATE_START_TIME = 'v3.3.10';
export var MINIMUM_VERSION_FOR_CC_TEXT_TRACK_WORKAROUND_REMOVAL = 'v3.3.10';
export var MINIMUM_VERSION_FOR_UPSTREAM_PATCH = 'v41000';
function parseShakaVersion(shakaVersion) {
    var _allComponents_;
    var allComponents = shakaVersion.split('-');
    var baseComponents = allComponents[0].substring(1).split('.');
    var baseNumbers = baseComponents.map(function(v) {
        return parseInt(v, 10);
    });
    var forkVersion = parseInt((_allComponents_ = allComponents[1]) === null || _allComponents_ === void 0 ? void 0 : _allComponents_.substring(1), 10);
    return _to_consumable_array(baseNumbers).concat([
        forkVersion
    ]);
}
export function isVersionCompliant(version, compliantVersion) {
    var versionComponents = parseShakaVersion(version);
    var testComponents = parseShakaVersion(compliantVersion);
    for(var i = 0; i < versionComponents.length; i++){
        var v = versionComponents[i];
        var t = testComponents[i] || 0;
        if (v < t) {
            return false;
        } else if (v > t) {
            return true;
        }
    }
    return true;
}

//# sourceMappingURL=shaka-version-utils.js.map